import * as React from "react";

const NISAddToWishListIcon: React.FC = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M13.0938 7C13.0938 7.51826 12.6739 7.93779 12.1562 7.93779H7.9375V12.1565C7.9375 12.6748 7.51768 13.0938 7 13.0938C6.48232 13.0938 6.0625 12.6748 6.0625 12.1565V7.93779H1.84375C1.32607 7.93779 0.90625 7.51826 0.90625 7C0.90625 6.48174 1.32607 6.06279 1.84375 6.06279H6.0625V1.84404C6.0625 1.32578 6.48232 0.90625 7 0.90625C7.51768 0.90625 7.9375 1.32578 7.9375 1.84404V6.06279H12.1562C12.6748 6.0625 13.0938 6.48145 13.0938 7Z" fill="#2B5197"/>
</svg>

    );
};

export default React.memo(NISAddToWishListIcon);
